import { useMemo } from 'react';
import { safeDecimal } from '@/helpers/number';
import { useGetAllocateInfo } from '@/query/queries/investing/useGetAllocateInfo';

/* Hook that used to retrieve status of Confirmed allocation */
export const useConfirmedAllocationStatus = () => {
  const { data: allocatedInfo, isLoading, isFetching } = useGetAllocateInfo();

  const accounts = useMemo(
    () => allocatedInfo?.accounts || [],
    [allocatedInfo],
  );

  const accountsByGroup = useMemo(() => {
    return accounts.reduce((res, acc) => {
      res[acc.group] = acc;
      return res;
    }, {});
  }, [accounts]);

  const availableCash = safeDecimal(accountsByGroup.cash?.amount);
  const bonusAmount = safeDecimal(allocatedInfo?.bonus_amount);
  const allocatedBonusAmount = safeDecimal(
    allocatedInfo?.allocated_bonus_amount,
  );
  const allocatedGroupA = safeDecimal(accountsByGroup.conservative?.amount);
  const allocatedGroupB = safeDecimal(accountsByGroup.moderate?.amount);

  const totalAllocated = allocatedGroupA.plus(allocatedGroupB).toNumber();
  const totalCash = allocatedInfo
    ? safeDecimal(allocatedInfo.total_allocated).plus(availableCash).toNumber()
    : 0;

  return {
    accounts,
    accountsByGroup,
    data: allocatedInfo,
    availableCash: availableCash.toNumber(),
    totalAllocated,
    allocatedGroupA: allocatedGroupA.toNumber(),
    allocatedGroupB: allocatedGroupB.toNumber(),
    totalCash,
    bonusAmount: bonusAmount.toNumber(),
    allocatedBonusAmount: allocatedBonusAmount.toNumber(),
    isLoading: isLoading || isFetching,
  };
};
